module.exports = __webpack_public_path__ + "static/media/iconCanvas03.317c92c0.svg";